import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "border p-2 p-lg-4 border-dark border-opacity-10" }
const _hoisted_6 = { class: "mb-15 mb-md-20" }
const _hoisted_7 = { class: "mb-15 mb-md-20" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "mb-15 mb-md-20" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = { class: "col-md-12 mb-3" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "d-flex align-items-right" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_26 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_27 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_28 = { class: "card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5" }
const _hoisted_29 = { class: "fw-medium text-muted me-8" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-semibold text-dark" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-semibold text-dark" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_37 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "redeForm",
          onSubmit: _ctx.payer,
          "validation-schema": _ctx.redeSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "card-title fw-bold mb-15 mb-lg-20 mb-xl-25" }, null, -1)),
              _withDirectives(_createElementVNode("div", {
                class: "alert alert-primary fs-md-15 fs-lg-16",
                role: "alert"
              }, _toDisplayString(_ctx.messagePromotion), 513), [
                [_vShow, _ctx.messagePromotion != '']
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "alert alert-danger fs-md-15 fs-lg-16",
                role: "alert"
              }, _toDisplayString(_ctx.messagePenalite), 513), [
                [_vShow, _ctx.messagePenalite != '']
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    for: "abonnement",
                    class: "form-label fw-medium text-black"
                  }, " ABONNEMENTs ", -1)),
                  _createVNode(_component_Field, {
                    name: "abonnement",
                    modelValue: _ctx.abonnement,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.abonnement) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        "filter-results": false,
                        "min-chars": 2,
                        "resolve-on-load": false,
                        delay: 0,
                        searchable: true,
                        "options-limit": 300,
                        options: async (query) => {
                      // return await getAbonnementFromBaseWithKey(query)
                      const results = await _ctx.getAbonnementFromBaseWithKey(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [{ value: '', label: 'Aucun enregistrement trouvé' }];
                      } else {
                        return [];
                      }
                    },
                        noOptionsText: "Tapez au moins deux caractères",
                        placeholder: "Rechercher un abonnement"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "abonnement",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Mode de paiement ", -1)),
                    _createVNode(_component_Field, {
                      name: "mode",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mode) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.modeOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un mode" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mode",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", {
                        for: "duree",
                        class: "form-label fw-medium text-black"
                      }, " Durée abonnement ", -1)),
                      _createVNode(_component_Field, {
                        name: "montantRemise",
                        modelValue: _ctx.montantRemise,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.montantRemise) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black d-none"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Field, {
                        name: "montantPenalite",
                        modelValue: _ctx.montantPenalite,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.montantPenalite) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black d-none"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Field, {
                        name: "duree",
                        modelValue: _ctx.duree,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.duree) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "duree",
                        class: "text-danger"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "montant",
                        class: "form-label fw-medium text-black"
                      }, " Montant ", -1)),
                      _createVNode(_component_Field, {
                        name: "montant",
                        modelValue: _ctx.montant,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.montant) = $event)),
                        disabled: true,
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "montant",
                        class: "text-danger"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date d'opération ", -1)),
                        _createVNode(_component_Field, {
                          name: "dateOperation",
                          type: "date",
                          class: "form-control shadow-none rounded-0 text-black"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "dateOperation",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "montantSaisi",
                        class: "form-label fw-medium text-black"
                      }, " Montant ", -1)),
                      _createVNode(_component_Field, {
                        name: "montantSaisi",
                        modelValue: _ctx.montantSaisi,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.montantSaisi) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "montantSaisi",
                        class: "text-danger"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Justificatif ", -1)),
                        _createVNode(_component_Field, {
                          name: "contenu",
                          cols: "3",
                          rows: "6",
                          as: "textarea",
                          placeholder: "Ecrire votre contenu",
                          class: "form-control shadow-none rounded-0 text-black"
                        }, {
                          default: _withCtx(({ field }) => [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 8, _hoisted_18), [
                              [_vModelText, field.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "contenu",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Pièces jointes "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "urlImage",
                          type: "file",
                          accept: "image/jpeg, image/png application/pdf",
                          onChange: _ctx.onFileChange,
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Choisissez une image"
                        }, null, 8, ["onChange"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "urlImage",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[16] || (_cache[16] = _createElementVNode("button", {
                      class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                      type: "submit"
                    }, " Ajouter ", -1)),
                    _createVNode(_component_router_link, {
                      to: "/liste-virements",
                      class: "btn btn-danger transition border-0 lh-1 fw-medium"
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                        _createElementVNode("span", { class: "position-relative" }, null, -1),
                        _createTextVNode("Annuler ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "REDEVANCES", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, "TOTAL IMPAYE : " + _toDisplayString(_ctx.somRedevance), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("table", _hoisted_31, [
              _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " # "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Année "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Loyer "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Date Redevance "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Etat ")
                ])
              ], -1)),
              (_ctx.redevances)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redevances, (redv, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("th", _hoisted_33, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(redv.annee), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(redv.montant), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.format_date(redv.dateRedevance)), 1),
                        _cache[20] || (_cache[20] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary" }, [
                          _createElementVNode("span", { class: "badge text-outline-danger" }, "En attente")
                        ], -1))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_37, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "shadow-none lh-1 fw-bold ps-0",
                        colspan: "4"
                      }, " AUCUNE REDEVANCE TROUVE ")
                    ], -1)
                  ]))]))
            ])
          ])
        ])
      ])
    ])
  ]))
}